import React from 'react';
import { Card, Section, Text } from 'seek-style-guide/react';

export default function ResultsError() {
  return (
    <Card>
      <Section>
        <Text subheading>Oops, looks like something went wrong&hellip;</Text>
        <Text>Try refreshing the page, or modifying your search criteria.</Text>
      </Section>
    </Card>
  );
}
